// Module
var code = "<span class=\"cs-icon-protected-server contricon-stack-container\"> <i cs-icon=\"shield\"></i> <i cs-icon=\"longArrowRight\"></i> </span>";
// Exports
var _module_exports =code;;
var path = '/views/cs-icon-protected-server.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;